var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");

var AbstractViewerController = require("./../../abstractViewerController.js");

var RectangleInteractionView = require("./rectangleInteractionView.js");
var RectangleInteractionModel = require("./rectangleInteractionModel.js");

var RectangleViewerController = function(archLayers, dependencies, configuration) {
    AbstractViewerController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(RectangleViewerController, AbstractViewerController);
RectangleViewerController.inject = AbstractViewerController.inject;

module.exports = RectangleViewerController;

RectangleViewerController.prototype.beforeLoad = function () {
    AbstractViewerController.prototype.beforeLoad.call(this);
};

RectangleViewerController.prototype.getDataType = function () {
    return cio_datamodel.RectangleData;
};

RectangleViewerController.prototype.getInteractionViewType = function () {
    return RectangleInteractionView;
};

RectangleViewerController.prototype.getInteractionModelType = function () {
    return RectangleInteractionModel;
};
